import './App.css';
import Footer from './components/Footer';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
// import Home from './pages/Home';
import Layout from './components/Layout';
import SewaMilikPanel from './pages/SewaMilikPanel';
import SimulasiPenghematan from './pages/SimulasiPenghematan';
import MitraEnergi from './pages/MitraEnergi';
import TeknologiKami from './pages/TeknologiKami';
import TentangKami from './pages/TentangKami';
import Form from './pages/Form';
import FormSimulasi from './components/FormSimulasi';
import FormSewaMilik from './components/FormSewaMilik';
import Login from './pages/Login';

function App() {
  return (
    <>
      <Router>
        <Layout title="Khatulistiwa Power">
          <Switch>
            <Route exact path="/">
              {/* <Home /> */}
              <SewaMilikPanel />
            </Route>
            <Route exact path="/sewa-milik-panel">
              <SewaMilikPanel />
            </Route>
            <Route exact path="/simulasi-penghematan">
              <SimulasiPenghematan />
            </Route>
            <Route exact path="/mitra-energi">
              <MitraEnergi />
            </Route>
            <Route exact path="/teknologi-kami">
              <TeknologiKami />
            </Route>
            <Route exact path="/tentang-kami">
              <TentangKami />
            </Route>
            <Route exact path="/isi-formulir">
              <Form />
            </Route>
            <Route exact path="/mulai-simulasi">
              <FormSimulasi />
            </Route>
            <Route exact path="/formulir-sewa-panel">
              <FormSewaMilik />
            </Route>
            <Route exact path="/login">
              <Login />
            </Route>
          </Switch>
        </Layout>
        <Footer />
      </Router>
    </>
  );
}

export default App;
